import React, { useCallback } from 'react'
import styled from 'styled-components'
import { t } from 'i18next'
import CustomDatePicker from '../Forms/CustomDatePicker'
import { Col, Form, Row } from 'react-bootstrap'

const StyledWrapper = styled.div`


  .form-group {
    padding-left:20px;

    @media screen and (min-width: 460px) {
      width: auto;
    }
  }
`

const DateRangeFilter = ({ dateFrom, setDateFrom, dateTo, setDateTo }) => {
    const handleChangeDate = useCallback(setDate => date => {
    setDate(date)
    }, [])

  return (
    <StyledWrapper>
        <Row>
            <Col>
                <Form.Group className="mb-3">
                    <Form.Label>{t('from')}</Form.Label>
                    <CustomDatePicker
                        dateFormat="dd.MM.yyyy"
                        placeholderText={t('date')}
                        onChange={handleChangeDate(setDateFrom)}
                        showYearDropdown
                        selected={dateFrom}
                    />
                </Form.Group>
            </Col>
            <Col>
                <Form.Group className="mb-3">
                    <Form.Label>{t('to')}</Form.Label>
                    <CustomDatePicker
                        dateFormat="dd.MM.yyyy"
                        placeholderText={t('date')}
                        onChange={handleChangeDate(setDateTo)}
                        showYearDropdown
                        selected={dateTo}
                    />
                </Form.Group>
            </Col>
        </Row>
    </StyledWrapper>
  )
}
export default DateRangeFilter